import React, { Component } from 'react';
import { connect } from 'react-redux';

import routes from '../Constants/routes';
import helpers from '../Utils/helpers';
import GoogleSignInButton from './Fundamentals/GoogleSignInButton/GoogleSignInButton';

class Login extends Component {
    render() {
        if (this.props.isAuthenticating) {
            return null;
        }

        //let location = (this.props.location && this.props.location.pathname) || '/';
        // Keep the query string: deep links (e.g. from Slack or Puzzel) carry their parameters there.
        let location = window.location.pathname + window.location.search;

        if (window.location.pathname.indexOf(routes.logout) > -1) {
            location = '/';
        }

        return (
            <div className="loginForm position-absolute-center">
                <div className="ml-96 mr-96 mt-24 border-bottom">
                    <h1 className="mb-16">Sign in</h1>
                </div>
                <div className="position-absolute-center">
                    <GoogleSignInButton label="Sign in with Google" href={`${helpers.getFullApiHostname()}/api/auth/login?returnPath=${encodeURIComponent(location)}`} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isAuthenticating: state.CommonReducer.authenticating,
    };
}

export default connect(mapStateToProps)(Login);
